import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import styles from "./Verificarcert.module.css";
import { postVerificarArchivo } from "../../../redux/actions";

const VerificarPDF = () => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [resultado, setResultado] = useState(null);
  const [errorMensaje, setErrorMensaje] = useState("");

  const validarCampos = () => {
    if (!file) {
      setErrorMensaje("Debe seleccionar un archivo PDF para verificar.");
      return false;
    }
    setErrorMensaje("");
    return true;
  };

  const handleVerificar = async (e) => {
    e.preventDefault();
    if (!validarCampos()) return;

    try {
      const data = await dispatch(postVerificarArchivo(file));
      setResultado(data);
      Swal.fire({
        icon: data.estado ? "success" : "warning",
        title: "Resultado de Verificación",
        text: data.mensaje,
      });
      setFile(null);
    } catch (err) {
      console.error("Error al verificar el archivo:", err);
      Swal.fire({
        icon: "error",
        title: "Error al verificar el PDF",
        text: "Ocurrió un problema al procesar la verificación. Intente nuevamente.",
      });
    }
  };

  return (
    <div className={styles.formContainer}>
      <h2 className={styles.title}>Verificar autenticación de certificado Incolab services</h2>

      <form onSubmit={handleVerificar} className={styles.form}>
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files[0])}
          className={styles.inputFile}
        />

        {file && (
          <p className={styles.fileName}>
            Archivo seleccionado: <strong>{file.name}</strong>
          </p>
        )}

        {errorMensaje && <p className={styles.error}>{errorMensaje}</p>}

        <button type="submit" className={styles.button}>
          Verificar PDF
        </button>
      </form>

      {resultado && (
        <div className={styles.resultado}>
          <p>
            <strong>Estado:</strong>{" "}
            {resultado.estado ? "Válido ✅" : "No válido ❌"}
          </p>
          <p>{resultado.mensaje}</p>
        </div>
      )}
    </div>
  );
};

export default VerificarPDF;
